import React, { Component } from "react";
import axios from "axios";
import { Row, Col } from "react-grid-system";
import Avatar from "react-avatar";
import Button from "@material-ui/core/Button";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import { Carousel } from "react-responsive-carousel";
import ReactPlayer from "react-player";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { initKakao } from "kakao-js-sdk";
initKakao("61d6650f4182563575f8ef44648ea983");

import $ from "jquery";

import ScaleLoader from "react-spinners/ScaleLoader";

class HappyQR extends Component {
  constructor(props) {
    super(props);

    this.state = {
      qrkey: props.match.params.qrkey,
      defaultinfo: {
        use: 1,
        del: 0,
        title: "",
        contents: "",
        img1: "",
        img2: "",
        img3: "",
        classify: "",
      },
      mediaslideridx: 0,
      medialist: [],
      buttonlist: [],
      opengallery: true,
      loading: false,
      showpreimg: false,
    };
  }

  componentDidMount() {
    this.getHappyQRInfo(this.state.qrkey);

    $(document).ready(function () {
      console.log("");
      console.log("[window ready] : [start]");
      console.log("");

      // [현재 접속된 url 정보 및 접속 브라우저 확인]
      // [카카오톡 인앱 브라우저 >> 안드로이드 모바일 기종 인 경우 >> 크롬 브라우저 이동 실시]
      var Url = window.location.href;
      var Agent = navigator.userAgent.toLowerCase();
      console.log("");
      console.log("[window ready] : [접속 Url] : " + Url);
      console.log("[window ready] : [접속 Agent] : " + Agent);
      console.log("");
      //alert(Agent);

      if (Agent.includes("kakao")) {
        // 카카오 브라우저로 실행 시킨 경우
        // 먼저, 카카오 인앱 브라우저 닫기
        window.location.href = "kakaotalk://inappbrowser/close";
        if (navigator.userAgent.match(/iPhone|iPad/i)) {
          // 아이폰 접속 경우
          console.log("");
          console.log("[window ready] : [접속 모바일] : " + "[아이폰]");
          console.log("");
        } else {
          // 안드로이드 접속 경우
          console.log("");
          console.log("[window ready] : [접속 모바일] : " + "[안드로이드]");
          console.log("");
          // 크롬으로 새창 열기
          window.location.href =
            "intent://" +
            window.location.href.replace(/https?:\/\//i, "") +
            "#Intent;scheme=http;package=com.android.chrome;end";
        }
      }
    });
  }

  getHappyQRInfo(qrkey) {
    console.log(qrkey);
    axios
      .post("https://happyqr.net/api/starname/api/getHappyQRInfo", {
        qrkey: qrkey,
      })
      .then((data) => {
        if (data.data.code == 200) {
          console.log(data.data);
          if (data.data.info.img3 != null && data.data.info.img3.length > 0) {
            this.setState({ showpreimg: true });
          }

          this.setState({
            defaultinfo: data.data.info,
            medialist: data.data.medialist,
            buttonlist: data.data.buttons,
          });
        }
      })
      .catch((error) => {
        console.log("error : ", error);
      });
  }

  renderHeader() {
    return (
      <img
        src={"/rc_logo_white.png"}
        style={{ paddingTop: "2%", height: "75%" }}
      ></img>
    );
  }

  renderDefaultInfo() {
    const info = this.state.defaultinfo;
    return (
      <div style={{ width: "100%", padding: "5px" }}>
        <Row style={{ margin: "0px" }}>
          <Avatar src={info.img1} size="60" round="5px"></Avatar>
          <Col>
            <div style={{ fontSize: "revert", fontWeight: "bolder" }}>
              {info.title}
            </div>
            <div style={{ fontSize: "small" }}>{info.contents}</div>
          </Col>
        </Row>
      </div>
    );
  }

  onClickButton(item) {
    if (item.type === "LINK") {
      window.location.href = item.desc;
    } else if (item.type === "CALL") {
      window.location.href = "tel:" + item.desc;
    } else if (item.type === "MAP") {
      window.location.href =
        "https://map.naver.com/v5/search/" + item.desc.replace(/ /gi, "+");
    } else if (item.type === "GALLERY") {
      window.location.href = "/gallery/" + item.no;
    } else if (item.type === "PDF/VIDEO") {
      window.open(item.desc);
    } else if (item.type === "KAKAO") {
      console.log("on click kakao - happyqr");

      this.setState({ loading: false });

      const info = this.state.defaultinfo;
      window.Kakao.Share.sendCustom({
        templateId: 91637,
        templateArgs: {
          titleimage: info.img2,
          subimage: info.img1,
          qrcodeimage:
            "https://chart.apis.google.com/chart?chs=300x300&cht=qr&chl=https://happyqr.net/"+this.state.qrkey,
          title: info.title,
          desc: info.contents,
          qrkey: this.state.qrkey,
        },
      });
    }
  }

  onCloseGalleryDialog = () => {
    this.setState({ opengallery: false });
  };

  onChangeCarousel = (index) => {
    console.log(index);
    this.setState({
      mediaslideridx: index,
    });
  };

  render() {
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 5,
      arrows: false,
    };

    var gallery_settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };

    if (this.state.showpreimg) {
      const info = this.state.defaultinfo;
      return (
        <div className="app">
          <div className="main">
            <div
              style={{ width: "100%", textAlign: "center", padding: "20px" }}
            >
              <img
                style={{ maxWidth: "100%", minWidth: "300px", height: "auto" }}
                src={info.img3}
              />
            </div>
            <Button
              style={{
                margin: 20,
                backgroundColor: "#ed1c24",
                color: "white",
              }}
              onClick={() => this.setState({ showpreimg: false })}
            >
              상세 보기
            </Button>
          </div>
        </div>
      );
    } else {
      return (
        <div className="app">
          <div className="main">
            {this.renderDefaultInfo()}
            <div
              style={{
                flex: 1,
                backgroundColor: "white",
                alignItems: "center",
                display: "flex",
              }}
            >
              <Carousel
                showThumbs={false}
                showArrows={false}
                swipeScrollTolerance={30}
                showStatus={false}
                autoPlay={false}
                preventMovementUntilSwipeScrollTolerance={true}
                onChange={this.onChangeCarousel}
                swipeable={true}
                selectedItem={this.state.mediaslideridx}
              >
                {this.state.medialist.map((item, index) => {
                  if (item.type == "VOD") {
                    return (
                      <div key={index} style={{ width: "100%" }}>
                        <ReactPlayer
                          width="100%"
                          controls={true}
                          autoPlay={false}
                          playing={
                            index != this.state.mediaslideridx ? false : true
                          }
                          url={item.imgurl}
                        />
                      </div>
                    );
                  } else if (item.type == "IMG") {
                    return (
                      <div key={index} style={{ width: "100%" }}>
                        <img src={item.imgurl} />
                      </div>
                    );
                  }
                })}
              </Carousel>
            </div>
          </div>
          <div
            className="footer"
            style={{
              paddingTop: "10px",
              paddingBottom: "5px",
              borderTop: "1px solid #eee",
            }}
          >
            <Slider {...settings}>
              {/*you can add styling for your button*/}
              {this.state.buttonlist.map((item, index) => {
                if (item.type === "KAKAO") {
                  return (
                    <Col
                      id="kakao-link-btn"
                      key={index}
                      onClick={() => this.onClickButton(item)}
                    >
                      <div
                        style={{
                          width: 80,
                          whiteSpace: "nowrap",
                          textAlign: "center",
                          marginRight: "2px",
                          marginLeft: "2px",
                        }}
                      >
                        <img
                          src={item.iconurl}
                          style={{
                            width: 28,
                            height: 22,
                            marginLeft: "auto",
                            marginRight: "auto",
                          }}
                        ></img>
                      </div>
                      <div
                        style={{
                          width: 80,
                          whiteSpace: "nowrap",
                          textAlign: "center",
                          marginRight: "2px",
                          marginLeft: "2px",
                        }}
                      >
                        <p>{item.title}</p>
                      </div>
                    </Col>
                  );
                } else {
                  return (
                    <Col key={index} onClick={() => this.onClickButton(item)}>
                      <div
                        style={{
                          width: 80,
                          whiteSpace: "nowrap",
                          textAlign: "center",
                          marginRight: "2px",
                          marginLeft: "2px",
                        }}
                      >
                        <img
                          src={item.iconurl}
                          style={{
                            width: 28,
                            height: 22,
                            marginLeft: "auto",
                            marginRight: "auto",
                          }}
                        ></img>
                      </div>
                      <div
                        style={{
                          width: 80,
                          whiteSpace: "nowrap",
                          textAlign: "center",
                          marginRight: "2px",
                          marginLeft: "2px",
                        }}
                      >
                        <p>{item.title}</p>
                      </div>
                    </Col>
                  );
                }
              })}
            </Slider>
          </div>

          <div className="sweet-loading" style={{ position: "absolute" }}>
            <ScaleLoader
              size={150}
              color={"#123abc"}
              loading={this.state.loading}
              speedMultiplier={1.5}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        </div>
      );
    }
  }
}

export default HappyQR;
